import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import NotFound from './pages/NotFound';
import FoodArticle from './pages/FoodArticle';
import { PAGE_MAP } from './data/allFoods';

function ArticleRoute() {
  const { slug } = useParams();
  const page = PAGE_MAP[slug];

  if (!page) {
    return <NotFound />;
  }

  return <FoodArticle page={page} />;
}

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/om" element={<About />} />
        <Route path="/:slug" element={<ArticleRoute />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
